module.exports = __webpack_public_path__ + "img/Sleeves-Front-Gd-Hc-Ic.7379fea3.png";